module.exports = __webpack_public_path__ + "static/media/MicrosoftButton.10d4de5d.png";